// Mirror of functions/lib/welcomeEmailTemplate.js, for the dashboard's live preview. The
// functions own the real check; keep the two in step through their identical test cases.
export const PLACEHOLDERS = ['name', 'email', 'link'];
const PLACEHOLDER_PATTERN = /\{\{\s*([^{}]*?)\s*\}\}/g;
const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export function isValidEmail(value) {
    return typeof value === 'string' && EMAIL_PATTERN.test(value.trim());
}

export function placeholdersIn(text) {
    return Array.from(String(text || '').matchAll(PLACEHOLDER_PATTERN), (match) => match[1]);
}

export function templateProblems(template) {
    const problems = [];
    const name = String(template?.name || '').trim();
    const subject = String(template?.subject || '');
    const body = String(template?.body || '');

    if (!name) problems.push('Skabelonen mangler et navn.');
    if (!subject.trim()) problems.push('Skabelonen mangler et emne.');
    if (!body.trim()) problems.push('Skabelonen mangler en tekst.');
    if (!isValidEmail(template?.reply_to)) problems.push('Svar-til skal være en gyldig emailadresse.');

    const unknown = [...placeholdersIn(subject), ...placeholdersIn(body)]
        .filter((placeholder) => !PLACEHOLDERS.includes(placeholder));
    Array.from(new Set(unknown)).forEach((placeholder) => {
        problems.push(`{{${placeholder}}} er ikke en kendt pladsholder. Brug {{name}}, {{email}} eller {{link}}.`);
    });
    if (placeholdersIn(subject).includes('link')) problems.push('Linket hører til i teksten, ikke i emnet.');
    if (!placeholdersIn(body).includes('link')) problems.push('Teksten skal indeholde {{link}}, ellers kan modtageren ikke komme ind.');

    return problems;
}

function fill(text, values) {
    return String(text || '').replace(PLACEHOLDER_PATTERN, (whole, placeholder) =>
        Object.prototype.hasOwnProperty.call(values, placeholder) ? String(values[placeholder] ?? '') : whole,
    );
}

export function renderWelcomeEmail(template, { name, email, link }) {
    const values = { name, email, link };
    return {
        subject: fill(template.subject, values).replace(/\s*\n\s*/g, ' ').trim(),
        body: fill(template.body, values),
    };
}

export function nameFromEmail(email) {
    return String(email || '').trim().split('@')[0];
}

// What the preview shows in place of the real link, which only exists once the email is sent.
export const PREVIEW_LINK = 'https://insights.aris-robotics.com/velkommen/…';
